import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      systemNotifications: {
        NOTIFICATIONS: 'Notifications',
        NOTIFICATION_SETTINGS: 'Notification Settings',
        ALL: 'All',
        UNREAD: 'Unread',
        MARK_ALL_AS_READ: 'Mark all as read',
        TODAY: 'Today',
        OLDER: 'Older',
        DELETE: 'Delete',
        MARK_AS_READ: 'Mark as read',
        MARK_AS_UNREAD: 'Mask as unread',
        NO_ALL_NOTIFICATIONS: 'We will notify you\n when something comes up.',
        NO_UNREAD_NOTIFICATIONS: 'You have read all notifications.',
        VIEW_ALL: 'View all',
        NO_NOTIFICATIONS: 'No notifications',
      },
      systemNotificationsSettings: {
        BACK_TO_SYSTEM_NOTIFICATIONS: 'Back to Notifications',
        EVENT: 'Event',
        SEND_EMAILS: 'Send emails',
        JUST_NOW: 'Just now',
        MORE_30S: '30s',
        M_AGO: 'm ago',
        H_AGO: 'h ago',
        DAY_1_AGO: ' day ago',
        DAY_AGO: ' days ago',
        WEEK_AGO: ' week ago',
        WEEKS_AGO: ' weeks ago',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      systemNotifications: {
        NOTIFICATIONS: 'Thông báo',
        NOTIFICATION_SETTINGS: 'Cài đặt thông báo',
        ALL: 'Tất cả ',
        UNREAD: 'Chưa đọc',
        MARK_ALL_AS_READ: 'Đánh dấu tất cả đã đọc ',
        TODAY: 'Hôm nay',
        OLDER: 'Cũ hơn',
        DELETE: 'Xóa',
        MARK_AS_READ: 'Đánh dấu đã đọc',
        MARK_AS_UNREAD: 'Đánh dấu chưa đọc',
        NO_ALL_NOTIFICATIONS:
          'Chúng tôi sẽ thông báo tới bạn\n khi có cập nhật mới.',
        NO_UNREAD_NOTIFICATIONS: 'Bạn đã đọc hết tất cả thông báo. ',
        VIEW_ALL: 'Xem tất cả',
        NO_NOTIFICATIONS: 'Không có thông báo',
      },
      systemNotificationsSettings: {
        BACK_TO_SYSTEM_NOTIFICATIONS: 'Quay về Thông Báo',
        EVENT: 'Sự kiện',
        SEND_EMAILS: 'Gửi email',
        JUST_NOW: 'Ngay bây giờ',
        MORE_30S: '30s',
        M_AGO: ' phút trước',
        H_AGO: ' giờ trước',
        DAY_1_AGO: ' ngày trước',
        DAY_AGO: ' ngày trước',
        WEEK_AGO: ' tuần trước',
        WEEKS_AGO: ' tuần trước',
      },
    },
  }),
)
